// extracted by mini-css-extract-plugin
export default {"resolutionLayout":"ResolutionLayout_resolutionLayout__-C9rn"};